import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0b0c10] text-slate-100 flex items-center justify-center p-6">
      <div className="max-w-md w-full rounded-2xl border border-white/10 bg-[#12161f] p-10 text-center" data-testid="payment-cancel-page">
        <XCircle className="w-14 h-14 mx-auto text-slate-500 mb-4" />
        <h1 className="font-heading text-3xl uppercase tracking-tight">Checkout cancelled</h1>
        <p className="text-slate-500 text-sm mt-2">No charge was made. You can upgrade any time.</p>
        <Link to="/">
          <Button className="mt-6 w-full bg-[#00f0ff] text-black hover:bg-[#33f4ff] font-bold" data-testid="back-to-studio-button">
            Back to the Studio
          </Button>
        </Link>
      </div>
    </div>
  );
}
